import type { RewardsTierDefinition } from './Rewards.types';

export const REWARDS_TIERS: readonly RewardsTierDefinition[] = [
  {
    id: 'explorer',
    tierId: '2qD3ZKFZw0vQUjDl',
    nameKey: 'rewards_tier_explorer_name',
    criteriaKey: 'rewards_tier_explorer_criteria',
    bannerBenefitsKey: 'rewards_banner_benefits_explorer',
    discount: 5,
    tripsRequired: 1,
    benefits: [{ id: 'explorer-discount', labelKey: 'rewards_benefit_discount', isDiscount: true }]
  },
  {
    id: 'adventurer',
    tierId: 'ZzG49mXBWVvvC7PB',
    nameKey: 'rewards_tier_adventurer_name',
    criteriaKey: 'rewards_tier_adventurer_criteria',
    bannerBenefitsKey: 'rewards_banner_benefits_adventurer',
    discount: 7.5,
    tripsRequired: 3,
    benefits: [
      { id: 'adventurer-discount', labelKey: 'rewards_benefit_discount', isDiscount: true },
      { id: 'adventurer-changes', labelKey: 'rewards_benefit_one_free_change' },
      {
        id: 'adventurer-offers',
        labelKey: 'rewards_benefit_exclusive_offers',
        infoKey: 'rewards_benefit_exclusive_offers_info'
      }
    ]
  },
  {
    id: 'expert',
    tierId: '6IdwFSMQmc03BC9g',
    nameKey: 'rewards_tier_expert_name',
    criteriaKey: 'rewards_tier_expert_criteria',
    bannerBenefitsKey: 'rewards_banner_benefits_expert',
    discount: 10,
    tripsRequired: 5,
    benefits: [
      { id: 'expert-discount', labelKey: 'rewards_benefit_discount', isDiscount: true },
      { id: 'expert-changes', labelKey: 'rewards_benefit_two_free_changes' },
      {
        id: 'expert-community',
        labelKey: 'rewards_benefit_community_invite',
        infoKey: 'rewards_benefit_community_invite_info'
      },
      {
        id: 'expert-experiences',
        labelKey: 'rewards_benefit_unique_experiences',
        infoKey: 'rewards_benefit_unique_experiences_info'
      },
      {
        id: 'expert-meetup',
        labelKey: 'rewards_benefit_founder_meetup',
        infoKey: 'rewards_benefit_founder_meetup_info'
      }
    ]
  }
];
